import React from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { EVENT_IMG } from '../constants';

const styles = () => ({
  bg: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    backgroundColor: '#ffffff',
    position: 'relative',
  },
});

class ComingSoon extends React.Component {
  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:1280px)').matches };
  }

  componentDidMount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').addListener(handler);
  }

  componentWillUnmount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:992px)').removeListener(handler);
  }

  render() {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          overflowY: 'auto',
          backgroundColor: '#ffffff',
          position: 'relative',
        }}
      >
        <Grid container>
          {this.state.matches ? (
            <Grid item xs={12}>
              <img src={`${EVENT_IMG}/coming-soon-mob.png`} alt={'img'} style={{ width: '100%' }} />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <img src={`${EVENT_IMG}/comingsoon_web.png`} alt={'img'} style={{ width: '100%' }} />
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ComingSoon);
